<!-- 
  远程搜索单选框 组件
  prop: 
    item: 绑定对象
    form: form表单数据对象
    module: 需要异步请求的模块名
    moduleName: 当前模块名
    supplierId: 供应商id
 -->

<template>
  <div>
    <div class="item-select" :class="{disable: (item && item.nonEditable) || disabled}">
      <el-input
        :placeholder="'请点击“选择”添加'"
        v-if="!form[item.attr].id"
        :readonly="true"
      >
      </el-input>
      <span class="item" v-if="form && form[item.attr].value">
        <span class="text">{{form[item.attr].value}}</span>
        <i class="del el-icon-close" @click="del"></i>
      </span>
      <!-- 回、付款 -->
      <span class="item" v-if="attrValue">
        <span class="text">{{attrValue.value}}</span>
        <i class="del el-icon-close" @click="del"></i>
      </span>
      <el-button type="text" class="select-btn" @click="handleSelect">选择</el-button>
    </div>
    <!-- 远程搜索下拉框 -->
    <div class="remote-select" v-clickoutside="hide" v-if="showRemote">
      <div class="search">
        <input class="search-input" v-model="value" @keyup="handleSearch" placeholder="输入关键词进行搜索">
        </input>
        <i class="el-icon-search"></i>
      </div>
      <div class="scroll-con" v-loading="loading">
        <el-radio-group v-model="id" class="list-con">
          <div class="item" v-for="item in listData" @change="saveObj(item)">
            <el-radio :label="item.id">{{item.value}}</el-radio>
          </div>
        </el-radio-group>
        <div class="no-data" v-if="showNodata">
          暂无数据
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import * as api from 'src/api'
import Clickoutside from 'element-ui/lib/utils/clickoutside'
import { mapActions } from 'vuex'
let lazy

export default {
  props: {
    disabled: {
      type: Boolean,
      default: false
    },
    item: Object,
    form: Object,
    attrValue: {},
    module: String,
    moduleName: String,
    always: Boolean,
    supplierId: {},
    customerId: {},
    contractId: {}
  },
  data () {
    return {
      value: '',
      id: this.defaultId(),
      listData: [],
      showNodata: false,
      showRemote: false,
      url: {
        'supplier': '/supplier/getSupplierList.html',
        'purchase': '/purchase/getPurchaseList.html',
        'transfer': '/transfer/getTransferList.html',
        'warehouse': '/warehouse/getWarehouseList.html',
        'returnedPurchase': '/returnedPurchase/getReturnedPurchaseList.html',
        'inventory': '/inventory/getInventoryList.html',
        'contract': '/contractApi/getContractList.html',
        'customer': '/customerApi/getCustomers.html',
        'opportunity': '/opportunityApi/getOpportunitys.html',
        'contact': '/contactApi/getContacts.html',
        'assemble': '/assemble/getAssembleList.html',
        // 退料入库、生产成品入库、生产物料出库
        'returnedMateriel': '/productionOrder/getProductionOrderList.html',
        'materiel': '/productionOrder/getProductionOrderList.html',
        'finshedProduct': '/productionOrder/getProductionOrderList.html',
        'payment': '/paymentApi/getPaymentList.html',
        'workOrder': '/workOrder/getWorkOrder.html'
      },
      loading: false
    }
  },
  created () {
    if (!this.always) {
      this.getItem()
    }
  },
  methods: {
    ...mapActions([
      'setAttr'
    ]),
    // 打开下拉选择
    handleSelect () {
      this.showRemote = true
      if (this.always) {
        this.getItem()
      }
    },
    defaultId () {
      if (this.item) {
        return this.item.id || ''
      } else {
        return this.attrValue.id || ''
      }
    },
    // 删除
    del () {
      if (this.form) {
        this.form[this.item.attr] = ''
        this.setAttr(this.item.attr)
      }
      this.id = ''
      this.$emit('emitObj', '')
    },
    // 保存
    saveObj (item) {
      if (this.form) {
        this.form[this.item.attr] = item
        this.setAttr(this.item.attr)
      }
      if (this.always) {
        this.value = ''
      }
      this.$emit('emitObj', item)
      this.hide()
    },
    handleSearch (e) {
      let key = this.value.toString().trim()
      window.clearTimeout(lazy)
      if (key || e.keyCode === 8) { // 手动删除搜素值的时候允许空字符串
        lazy = window.setTimeout(() => { this.getItem(key) }, 300)
      }
    },
    getItem (key) {
      this.loading = true
      let url = this.url[this.module]
      let params = {
        nameLike: key,
        supplierId: this.supplierId
      }
      if (this.moduleName === 'returnedPurchase') {
        params.fromReturnedPurchase = 1
      } else if (this.moduleName === 'instock') {
        params.fromInstock = 1

        // 调拨入库、盘盈入库
        if (this.module === 'transfer' || this.module === 'inventory') {
          params.warehouseId = this.form.warehouseId.id
        }

        // 红冲合同
        if (this.module === 'contract') {
          params.isRed = 1
        }
        // 生产成品入库
        if (this.module === 'finshedProduct') {
          params.type = 'finshedProduct'
          params.warehouseId = this.form.warehouseId.id
        }
        // 退料入库
        if (this.module === 'returnedMateriel') {
          params.type = 'returnedMateriel'
          params.warehouseId = this.form.warehouseId.id
        }
      } else if (this.moduleName === 'outstock') {
        params.fromOutstock = 1
        // 调拨出库、盘亏出库
        if (this.module === 'transfer' || this.module === 'inventory') {
          params.warehouseId = this.form.warehouseId.id
        }
        // 工单出库
        if (this.module === 'workOrder') {
          params.fromOutstock = 1
        }
        // 物料出库
        if (this.module === 'materiel') {
          params.warehouseId = this.form.warehouseId.id
        }
      } else if (this.customerId) {
        params.customerId = this.customerId
      }
      if (this.contractId) {
        params.contractId = this.contractId
      }
      console.log(params)
      api.post(url, params, (data) => {
        this.loading = false
        this.listData = data.result
        if (this.listData.length === 0) {
          this.showNodata = true
        } else {
          this.showNodata = false
        }
      })
    },
    hide () {
      this.$nextTick(() => {
        this.showRemote = false
      })
    }
  },
  directives: { Clickoutside }
}
</script>

<style lang="less" scoped>
  @import '../../assets/less/remote-select.less';
  .item-select {
    &.disable {
      background-color: #eef1f6;
      border: 1px solid #d1dbe5;
      color: #bbb;
      &:after {
        content: '';
        position: absolute;
        width: 100%;
        height: 100%;
        left: 0;
        top: 0;
        opacity: 0;
        cursor: not-allowed;
      }
    }
  }
</style>
<style lang="less">
  .remote-select {
    .el-radio {
      .el-radio__label {
        margin-left: 10px;
        width: 270px;
        display: inline-block;
        line-height: 36px;
      }
    } 
  }
</style>


// WEBPACK FOOTER //
// remote-select.vue?29d958ce